<template>
  <div>
    <CCardBody class="py-0 pl-2 pr-0">
      <table class="table mb-0">
        <tbody>
          <div
            class="custom-width-total"
            v-for="(r, index) in actividades.filter(
              act => act.payload.pertenece_id == actividadPadre
            )"
            :key="index"
          >
            <tr class="custom-width-total">
              <td
                @click="toggleSubActividades(index)"
                class="custom-width"
                :class="
                  `${
                    actividades.filter(a => a.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
              >
                <span>
                  <CIcon
                    v-if="
                      actividades.filter(a => a.payload.pertenece_id == r.id)
                        .length > 0
                    "
                    name="cil-chevron-circle-down-alt"
                  />
                </span>
                {{ r.payload.nombre }}
              </td>
              <td
                @click="toggleSubActividades(index)"
                class="custom-width"
                :class="
                  `${
                    actividades.filter(a => a.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
              >
                {{ r.payload.tipo_pago }}
              </td>
              <td
                @click="toggleSubActividades(index)"
                class="custom-width"
                :class="
                  `${
                    actividades.filter(a => a.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
              >
                {{ r.payload.multiplicador_pago }}
              </td>
              <td
                @click="toggleSubActividades(index)"
                class="custom-width"
                :class="
                  `${
                    actividades.filter(a => a.payload.pertenece_id == r.id)
                      .length > 0
                      ? `cursor-p`
                      : ``
                  }`
                "
              >
                {{ r.payload.unidad }}
              </td>
              <td class="custom-width5 px-0">
                <p-check
                  class="p-svg p-curve"
                  name="check"
                  color="success"
                  v-model="r.selected"
                >
                  <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style="stroke: white;fill:white"
                    />
                  </svg>
                  Imprimir
                </p-check>
              </td>
              <td class="custom-width5">
                <router-link
                  :to="{ name: 'EditarActividad', params: { id: r.id } }"
                >
                  <CButton color="success" square size="sm">Editar</CButton>
                </router-link>
              </td>
              <td class="custom-width5">
                <CButton
                  :disabled="
                    actividades.filter(a => a.payload.pertenece_id == r.id)
                      .length > 0
                      ? true
                      : false
                  "
                  color="danger"
                  square
                  size="sm"
                  @click="toggleCancel(index, r)"
                  >Borrar</CButton
                >
              </td>
            </tr>
            <tr
              v-if="
                actividades.filter(p => p.payload.pertenece_id == r.id).length >
                  0
              "
            >
              <td class="py-0 pl-2 pr-0" colspan="7">
                <CCollapse
                  :show="subDetails.includes(index)"
                  class="m-0 custom-width-total"
                >
                  <table-collapse-activities
                    @click-cancel="toggleCancel"
                    @click-print="printNanoid"
                    :actividadPadre="r.id"
                    :actividades="actividades"
                  ></table-collapse-activities>
                </CCollapse>
              </td>
            </tr>
          </div>
        </tbody>
      </table>
    </CCardBody>
  </div>
</template>

<script>
import PrettyCheck from "pretty-checkbox-vue/check";

export default {
  name: "TableCollapseActivities",

  props: {
    actividades: {
      type: Array
    },
    actividadPadre: {
      type: Number
    }
  },

  data() {
    return {
      details: [],
      subDetails: [],
      itemModal: { id: "", name: "", index: "" }
    };
  },

  components: {
    TableCollapseActivities: () => import("./TableCollapseActivities.vue"),
    "p-check": PrettyCheck
  },

  methods: {
    toggleCancel(index, item) {
      this.$emit("click-cancel", index, item);
    },
    printNanoid(actividad) {
      this.$emit("click-print", actividad);
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    toggleSubActividades(index) {
      const positionSub = this.subDetails.indexOf(index);
      positionSub !== -1
        ? this.subDetails.splice(positionSub, 1)
        : this.subDetails.push(index);
    }
  }
};
</script>

<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width {
  width: 25%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100% !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
